// Flag name
export const LOGROCKET_BOOKING_FUNNEL_FLAG = 'consumer_analytics_enable_logrocket_events_com1285_20230727';
export const LOGROCKET_BOOKING_FUNNEL_PERCENT = 0.01; // Yes, only 1%
